// extracted by mini-css-extract-plugin
export default {"brandPromo":"HF-z","carousel":"IF-z"};